// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "button {\n  cursor: pointer;\n}\n\nbutton:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}", "",{"version":3,"sources":["webpack://src/components/custom-button/custom-button.scss"],"names":[],"mappings":"AAAA;EACE,eAAA;AACF;;AAEA;EACE,YAAA;EACA,mBAAA;AACF","sourcesContent":["button {\n  cursor: pointer,\n}\n\nbutton:disabled {\n  opacity: .5;\n  cursor: not-allowed;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
